import React from 'react';
import './timeline.scss'

export class Timeline extends React.Component<any> {

    render(): React.ReactNode {
        return (
            <div className="timeline container" id="portfolio">
                <div className="timeline__heading">
                    {this.props.data.title}
                </div>
                {
                    this.props.data.timeLineData.map((data: any, index:number) => {
                        return (
                            <div className="timeline__wrapper" key={index}>
                                <span className="timeline__title">{data.name}</span>
                                <span className="timeline__descryption">{data.cources}</span>
                                <span className="timeline__date-range">{data.acedomicYear}</span>
                                {data.grade ? <span className="timeline__date-range"><strong>Grade:</strong>{data.grade}</span>
                                 : <span className="timeline__date-range">{data.designation}</span>}
                            </div>
                        )
                    })
                }
            </div>
        )
    }

}
export default Timeline;